import AddressService from './AddressService';
import AuthenticationService from './AuthenticationService';
import DateService from './DateService';
import DocumentService from './DocumentService';
import EventService from './EventService';
import MsalAuthenticationService from './MsalAuthenticationService';
import PerilService from './PerilService';
import RouterService from './RouterService';
import StringService from './StringService';
import StylesService from './StylesService';
import ThirdPartyAuthenticationService from './ThirdPartyAuthenticationService';

export {
	AddressService,
	AuthenticationService,
	DateService,
	DocumentService,
	EventService,
	MsalAuthenticationService,
	PerilService,
	RouterService,
	StringService,
	StylesService,
	ThirdPartyAuthenticationService,
};